import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Käytämme evästeitä',
    description:
      'Käytämme evästeitä ja vastaavia teknologioita tämän kokemuksen tarjoamiseen. Ehdottoman välttämättömät evästeet ovat aina käytössä.',
    allow_label: 'Hyväksy kaikki evästeet',
    reject_label: 'Vain ehdottoman välttämättömät',
    settings_label: 'Evästeasetukset',
    policy_link_label: 'Tietosuoja- ja evästekäytäntö',
    categories_label: 'Luokat',
    always_on_label: 'Aina käytössä',
    required_label: 'Pakollinen',
    save_preferences_label: 'Tallenna asetukset',
    close_label: 'Sulje',
    allow_all_optional_categories_label: 'Salli kaikki valinnaiset luokat',
    save_error: 'Tietosuojavalintaasi ei voitu tallentaa. Yritä uudelleen.'
  },
  categories: {
    strictly_necessary: {
      name: 'Ehdottoman välttämättömät',
      purpose: 'Tarvitaan tämän kokemuksen tarjoamiseen, eikä niitä voi poistaa käytöstä.'
    },
    analytics: {
      name: 'Analytiikka',
      purpose: 'Mittaa, miten vierailijat käyttävät tätä kokemusta, jotta suorituskykyä voidaan parantaa.'
    },
    marketing: { name: 'Markkinointi', purpose: 'Tukee järjestäjän valitsemaa mainontaa ja markkinointia.' }
  }
};

export default locale;
